export default "__VITE_ASSET__jeNNCMi6__"